import { useEffect, useState } from 'react';
import { classArr, skillsImgArr } from '../../tempDB';
import CreateCharacterRace from './CreateCharacterRace';
import CreateCharacterClass from './CreateCharacterClass';
import { createNewCharacter, ICreationParams } from '../../mechanics/CreatingMechanic';
import { useAppDispatch, useAppSelector } from '../../store/store';
import { userSlice } from '../../store/reducers/userReducer';
import { sceneSlice } from '../../store/reducers/SceneReducer';
import { soundToPlay } from '../../mechanics/sounds/sound';
import BaseButton from '../ui/BaseButton';
import CreateCharacterInfo from './CreateCharacterInfo/CreateCharacterInfo';
import './CreateCharacter.scss'
import ImgWithFallback from '../ui/ImgWithFallback';

const CreateCharacter = () => {
    // redux const
    const dispath = useAppDispatch()
    const { setPlayerCharacter } = userSlice.actions
    const { setScene } = sceneSlice.actions
    const activeRace = useAppSelector(state => state.createCharacterReducer.activeRace)
    const activeClass = useAppSelector(state => state.createCharacterReducer.activeClass)
    const reduxClass = useAppSelector(state => state.createCharacterReducer.reduxClass)
    const fullImg = useAppSelector(state => state.createCharacterReducer.fullImg)
    // useState const
    const [name, setName] = useState('')
    const [formError, setFormError] = useState('')
    const [isNameValid, setIsNameValid] = useState(false)

    function validateName(name: string): string {
        let error = ''

        if (!name) {
            error = 'Name is required!'
        } else if (name.length < 3) {
            error = 'Name must be more then 3 characters!'
        } else if (name.length > 10) {
            error = 'Name not be more then 10 characters!'
        } else if (/\s/g.test(name)) {
            error = 'Should be no spaces in the name!'
        } else {
            error = ''
            setIsNameValid(true)
        }
        return error
    }

    function handleSubmit() {
        setFormError(validateName(name))
    }

    useEffect(() => {
        if (!formError && isNameValid) {
            setReduxNewCharacter()
        }
    }, [isNameValid, formError])

    const setReduxNewCharacter = () => {
        const creationParams: ICreationParams = {
            name,
            characterClass: reduxClass,
            activeRace,
            img: fullImg,
            icon: classArr[activeRace][activeClass].iconImg,
            skills: skillsImgArr[activeClass]
        }

        dispath(setPlayerCharacter(createNewCharacter(creationParams)))
        dispath(setScene("main"))
        soundToPlay("button")
    }

    return (
        <div className='create-character'>
            <div className="create-character__wrapper">
                <h1 className="create-character__title">
                    character creation
                </h1>
                <div className="create-character__content">
                    <div className="create-character__select">
                        <CreateCharacterRace />
                        <CreateCharacterClass />
                    </div>
                    <div className="create-character__bigimg">
                        <ImgWithFallback src={fullImg.webp} fallbackSrc={fullImg.img} />
                    </div>
                    <CreateCharacterInfo />
                </div>
                <form className="create-character__form">
                    {formError ? (<div className='create-character__form-error'>{formError}</div>) : null}
                    <input
                        type="text"
                        name='name'
                        autoComplete='off'
                        placeholder='CHARACTER NAME'
                        required
                        onChange={(e) => setName(e.target.value)} />
                    <BaseButton type='submit' name="Create" onClick={handleSubmit} />
                </form>
            </div>
        </div>
    );
};

export default CreateCharacter;